import { api } from '@/lib/api/client';
import { unwrap } from '@/lib/api/envelope';
import { Endpoints } from '@/lib/api/endpoints';
import type { ResponseEnvelope } from '@/types/api';
import type { OverviewKpis, VerificationRecord } from '@/types/verification';

export interface OverviewParams {
  clientId?: string;
  /** ISO-8601 (e.g. "2026-05-01T00:00:00Z"). Omit for "today". */
  from?: string;
  to?: string;
}

export async function fetchOverviewKpis(params: OverviewParams = {}): Promise<OverviewKpis> {
  const res = await api.get<ResponseEnvelope<OverviewKpis>>(Endpoints.analytics.overview, {
    params,
  });
  return unwrap(res);
}

export async function fetchRecentVerifications(
  limit = 10,
  clientId?: string,
): Promise<VerificationRecord[]> {
  const res = await api.get<ResponseEnvelope<VerificationRecord[]>>(Endpoints.verifications.list, {
    params: { limit, maskMobile: true, ...(clientId ? { clientId } : {}) },
  });
  return unwrap(res) ?? [];
}
